/**
 * E-Filing Component Registry (jurisdiction-agnostic)
 *
 * PreSetTaskDetailPage 가 task type 별 e-Filing 폼(예: ChangeAddressEFiling,
 * DirectIncorporationEFiling)을 직접 import 하지 않고 이 registry 에서 lookup.
 *
 * 각 jurisdiction 의 e-Filing 폼들은 자기 task type code 로 등록한다.
 *
 * 사용:
 *   // my/preset/efilings/index.ts (sideeffect)
 *   registerEFilingComponent('M32102', () => import('.../ChangeAddressEFiling.vue'));
 *
 *   // 호출
 *   const Component = await loadEFilingComponent('M32102');
 *   // 또는 defineAsyncComponent 결과 직접 등록 후 동기 lookup
 */

import type { Component } from 'vue';

const components: Record<string, Component> = {};

export function registerEFilingComponent(taskTypeCd: string, component: Component): void {
  if (!taskTypeCd) {
    console.warn('[efilingRegistry] taskTypeCd 누락 — 등록 스킵');
    return;
  }
  components[taskTypeCd] = component;
}

/** taskTypeCd 에 등록된 컴포넌트 반환. 없으면 null. */
export function getEFilingComponent(taskTypeCd: string): Component | null {
  if (!taskTypeCd) return null;
  return components[taskTypeCd] || null;
}

/** 등록된 모든 task type code 목록. */
export function getRegisteredEFilingTaskCodes(): string[] {
  return Object.keys(components);
}

/** 테스트용. */
export function _clearEFilingRegistry(): void {
  for (const k of Object.keys(components)) delete components[k];
}
